module.exports = __webpack_public_path__ + "img/product_chart_6.6f935dd0.png";